define(["jquery", "bootstrap"], function ($) {
    var SCAN = window.scan || {};
    var userTimeoutSeconds = SCAN.userTimeoutSeconds || 60;

    function idleLogout() {
        var t;

        function showModal() {
            // reset modal timer if chatbot is displaying
            if ($("#orbita-chat-iframe").css("display") == "block") {
                resetTimer();
            } else {
                if ($.magnificPopup) {
                    $.magnificPopup.close(); // close Magnific Popup prior to showing bootstrap modal
                    $(document).off("focusin.mfp");
                }
                $("#timeoutInterstitial").modal("show");
            }
        }

        function resetTimer() {
            clearTimeout(t);
            t = setTimeout(showModal, userTimeoutSeconds * 1000); // covert time to milliseconds
        }

        window.onmousemove = resetTimer;
        window.onmousedown = resetTimer; // catches touchscreen presses as well
        window.ontouchstart = resetTimer; // catches touchscreen swipes as well
        window.onclick = resetTimer; // catches touchpad clicks as well
        window.onkeypress = resetTimer;
        window.addEventListener("scroll", resetTimer, true); // improved; see comments

        resetTimer(); // run it now

        $("#timeoutInterstitial").on("shown.bs.modal", function (event) {
            $(this).attr("tabindex", 0);
            $(this).find(".close").focus();
        });
    }

    $(function () {
        if ($("#timeoutInterstitial").length > 0) {
            idleLogout();
        }
    });
});
